import { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Center, Container, Flex, Stack } from '@chakra-ui/react';
import PillarSurvey from './PillarSurvey';
import QuestionnaireHeader from './QuestionnaireHeader';
import baseService from '../../services/base';
import { typeMapping } from '../../pages/questionnaires/certifications/defaultValues';
import Loader from '../Feedback/Loader';

function initializeDefaultValues(themesData) {
 const defaultValues = {};

 themesData?.forEach((themeDataItem) => {
  themeDataItem?.levels?.forEach((level) => {
   level?.questions?.forEach((question) => {
    const { id_question, type, users_responses, options } = question;

    const questionName = `${typeMapping[type] || ''}_question_${id_question}_${
     themeDataItem?.themeId
    }`;

    let initialValue = {
     value: type === 'multiple_choice' ? [] : '',
     files: [],
     idResponse: null,
    };

    if (users_responses?.response) {
     if (type === 'multiple_choice' || type === 'multi_choice') {
      let responseParts = [];
      let canBeOld = false;
      if (users_responses.response.includes('||')) {
       responseParts = users_responses.response.split('||').map((part) => part.trim());
      } else if (
       users_responses.response.includes(',') &&
       !users_responses.response.includes('||')
      ) {
       canBeOld = true;
       responseParts = users_responses.response.split(',').map((part) => part.trim());
      } else {
       responseParts = [users_responses.response.trim()];
      }

      const selectedOptions = [];

      options?.forEach((option) => {
       if (responseParts.includes(option.description.trim())) {
        selectedOptions.push(option.description);
       } else if (
        !responseParts.includes(option.description.trim()) &&
        canBeOld &&
        users_responses.response.includes(option.description)
       ) {
        selectedOptions.push(option.description);
       }
      });

      initialValue = {
       value: type === 'multi_choice' ? selectedOptions[0] || '' : selectedOptions,
       files: users_responses.response_file || [],
       idResponse: users_responses.id_question_response,
      };
     } else {
      initialValue = {
       value: users_responses?.response,
       files: users_responses?.response_file || [],
       idResponse: users_responses?.id_question_response,
      };
     }
    }
    defaultValues[questionName] = initialValue;
   });
  });
 });

 return defaultValues;
}

const PillarsApp = ({ pillar, pillarIndex, surveyId, companyId, pillarId, userId }) => {
 const loadThemesAttempted = useRef(false);

 const [themesData, setThemesData] = useState([]);
 const [temasestaoprontos, settemasestaoprontos] = useState(false);
 const [defaultValues, setDefaultValues] = useState(null);

 const fetchedThemes = useMemo(() => new Set(), []);

 async function fetchThemeData(id_theme, id_pillar) {
  const url = `survey/diagnostic?id_theme=${id_theme}&id_user=${userId}&id_company=${companyId}&id_survey=${surveyId}&id_pillar=${id_pillar}`;
  const response = await baseService.get(url);
  const themeData = response?.data;

  const updatedQuestionsTheme = themeData?.questions_theme?.map((theme) => ({
   ...theme,
   questions: theme?.questions?.map((question) => ({
    ...question,
    id_theme: id_theme,
   })),
  }));

  return { ...themeData, questions_theme: updatedQuestionsTheme };
 }

 async function loadThemesData(pillar) {
  const themesResponses = [];

  for (const theme of pillar.themes) {
   if (!fetchedThemes.has(theme?.id_theme)) {
    fetchedThemes.add(theme?.id_theme);
    const themeData = await fetchThemeData(theme?.id_theme, pillar?.id_pillar);
    const questionsTheme = themeData?.questions_theme;
    questionsTheme?.sort((a, b) => a.nivel - b.nivel);
    themesResponses.push({
     themeId: theme?.id_theme,
     levels: questionsTheme,
    });
   }
  }

  setThemesData((prevData) => {
   const newData = [...prevData];
   //@ts-ignore
   themesResponses.forEach((themeResponse) => {
    const exists = newData.some((item) => item.themeId === themeResponse.themeId);
    if (!exists) {
     newData.push(themeResponse);
    }
   });

   return newData;
  });

  settemasestaoprontos(true);
 }

 useEffect(() => {
  if (!loadThemesAttempted.current && pillar && pillar?.themes) {
   loadThemesAttempted.current = true;
   loadThemesData(pillar);
  }
 }, [pillar]);

 useEffect(() => {
  if (temasestaoprontos && themesData?.length > 0) {
   const defaultValues = initializeDefaultValues(themesData);
   setDefaultValues(defaultValues);
  }
 }, [temasestaoprontos, themesData]);

 if (!temasestaoprontos || !pillar || !defaultValues) {
  return <Loader />;
 }

 return (
  <Container bg='#F5F5FB' maxW='100vw' minH='101vh' overflowX='hidden' p={0}>
   <QuestionnaireHeader
    tagLabel={'Diagnóstico de Maturidade ESG'}
    heading={pillar?.name_pillar}
    totalQuestions={`Pilar ${pillarIndex + 1}`}
    endDate={`${pillar?.themes?.length} ${
     pillar?.themes?.length === 1 ? 'tema' : 'temas'
    }`}
   >
    <Flex />
    <Stack spacing='12px' ml='auto'>
     <Button isDisabled variant='primary' width='300px' height='49px'>
      Enviar respostas
     </Button>
     <Flex gap='12px'>
      <Button variant='cancel' width='144px' height='49px'>
       Voltar
      </Button>
      <Button
       type='submit'
       variant='outline'
       color='#0073BB'
       borderColor='#0073BB'
       isDisabled
       width='144px'
       height='49px'
       pointerEvents='auto'
      >
       Salvar
      </Button>
     </Flex>
    </Stack>
   </QuestionnaireHeader>

   <Center
    my={['8px', '30px']}
    pb={['100px', '32px']}
    px={{ xl: '86px', '2xl': 'unset' }}
   >
    <Container maxW={'1280px'} p={0}>
     <PillarSurvey
      themes={pillar?.themes}
      themesData={themesData}
      defaultValues={defaultValues}
      userId={userId}
      companyId={companyId}
      surveyId={surveyId}
     />
    </Container>
   </Center>
  </Container>
 );
};

export default PillarsApp;
